import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IMouserButtonProps extends IBaseElementProps {
    /**
    * The part number of the product.  Example: 2N2222A
    */
    partNumber?: string;
    /**
    * The manufacturer of the product.  Example: Central Semiconductor
    */
    manufacturer?: string;
    /**
    * The template ID of the button.  Default is 1.
    */
    templateID?: number;
    /**
    * The language code of the button.  Default is en.
    */
    languageCode?: string;
    /**
    * The sType of the button.  Default is 1.
    */
    sType?: number;
    /**
    * The title of the button. For AODA purposes.
    */
    title?: string;
}

/**
 * MouserButton Component
 * @icon button
 * @block
 */
const MouserButton: React.FC<IMouserButtonProps> = ({
	id,
	className,
	classNames = [],
    partNumber = '',
    manufacturer = '',
    templateID = 1,
    languageCode = 'en',
    sType = 1,
    title = '',

}) => {
    const href = `https://www.mouser.com/access?pn=${partNumber}&sn=${manufacturer}`;
    const imgSrc = `https://buybutton.services.mouser.com/MouserBuyButton.ashx?partnumber=${partNumber}&manufacturer=${manufacturer}&templateid=${templateID}&languagecode=${languageCode}&stype=${sType}&`;
    if ( ! partNumber || ! manufacturer ) {
        return (
            <div
                className={className}
                id={id}
            >
                <span>MouserButton: Missing part number or manufacturer</span>
            </div>
        
        );
    }
    
    return (
        <a 
            href={href}
            target="_blank"
        >
            <img
                title={title}
                src={imgSrc}
            />
        </a>
    );
};

export default MouserButton;

  